@if (isOpen() && isEnabled()) {
  <div class="wide">
    <ng-content select="[wideContent]"></ng-content>
    <div class="arrow" ngbTooltip="{{ 'SIDEBAR.COLLAPSE' | translate }}" (click)="onToggle()">
      <i class="bi bi-chevron-left"></i>
    </div>
  </div>
} @else {
  <div class="narrow">
    @if (isEnabled()) {
      <ng-content select="[narrowContent]"></ng-content>
      <div class="arrow" ngbTooltip="{{ 'SIDEBAR.EXPAND' | translate }}" (click)="onToggle()">
        <i class="bi bi-chevron-right"></i>
      </div>
    }
  </div>
}
